export const InputID = 'SearchInput';
